import { render } from "./template.html?vue&type=template&id=9585ec00&ts=true&external"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"

import "./style.scss?vue&type=style&index=0&lang=scss&external"
import "./light.scss?vue&type=style&index=1&lang=scss&external"
import "./dark.scss?vue&type=style&index=2&lang=scss&external"
import "./default.scss?vue&type=style&index=3&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__